function computeEasterSunday(year: number): Date {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

function addDays(date: Date, days: number): Date {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
}

function dateKey(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

const FIXED_HOLIDAYS: Array<{ month: number; day: number; name: string }> = [
  { month: 1, day: 1, name: "Nowy Rok" },
  { month: 1, day: 6, name: "Trzech Króli" },
  { month: 5, day: 1, name: "Święto Pracy" },
  { month: 5, day: 3, name: "Konstytucji 3 Maja" },
  { month: 8, day: 15, name: "Wniebowzięcie NMP" },
  { month: 11, day: 1, name: "Wszystkich Świętych" },
  { month: 11, day: 11, name: "Święto Niepodległości" },
  { month: 12, day: 25, name: "Boże Narodzenie" },
  { month: 12, day: 26, name: "Boże Narodzenie (2. dzień)" }
];

export function getPolishHolidayName(date: Date): string | null {
  const fixed = FIXED_HOLIDAYS.find((holiday) => date.getMonth() + 1 === holiday.month && date.getDate() === holiday.day);
  if (fixed) return fixed.name;

  const key = dateKey(date);
  const easterSunday = computeEasterSunday(date.getFullYear());
  const movableHolidays: Array<{ date: Date; name: string }> = [
    { date: easterSunday, name: "Wielkanoc" },
    { date: addDays(easterSunday, 1), name: "Poniedziałek Wielkanocny" },
    { date: addDays(easterSunday, 60), name: "Boże Ciało" }
  ];
  return movableHolidays.find((holiday) => dateKey(holiday.date) === key)?.name ?? null;
}

export function isPolishHoliday(date: Date): boolean {
  return getPolishHolidayName(date) !== null;
}
